import { useEffect, useState } from "react";
import { apiClient, ApiError } from "../../lib/api-client";

interface AdminCoupon {
  id: string;
  code: string;
  kind: string;
  value: number;
  is_active: number;
}

export function AdminCouponsPage() {
  const [coupons, setCoupons] = useState<AdminCoupon[]>([]);
  const [form, setForm] = useState({ code: "", kind: "percent" as "percent" | "fixed_amount", value: 10 });
  const [message, setMessage] = useState<string | null>(null);

  function refresh() {
    apiClient.get<{ items: AdminCoupon[] }>("/admin/coupons").then((data) => setCoupons(data.items));
  }

  useEffect(refresh, []);

  async function handleCreate(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      await apiClient.post("/admin/coupons", form);
      setMessage("Cupom criado.");
      refresh();
    } catch (err) {
      setMessage(err instanceof ApiError ? err.message : "Falha ao criar cupom.");
    }
  }

  return (
    <div>
      <h2>Cupons</h2>
      <form onSubmit={handleCreate} className="card" style={{ marginBottom: "var(--space-6)", maxWidth: 420 }}>
        <div className="field">
          <label htmlFor="code">Código</label>
          <input id="code" required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
        </div>
        <div className="field">
          <label htmlFor="kind">Tipo</label>
          <select id="kind" value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value as "percent" | "fixed_amount" })}>
            <option value="percent">Percentual</option>
            <option value="fixed_amount">Valor fixo (centavos)</option>
          </select>
        </div>
        <div className="field">
          <label htmlFor="value">Valor</label>
          <input id="value" type="number" required value={form.value} onChange={(e) => setForm({ ...form, value: Number(e.target.value) })} />
        </div>
        {message && <p role="status">{message}</p>}
        <button className="btn" type="submit">
          Criar cupom
        </button>
      </form>

      <div className="card" style={{ overflowX: "auto" }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Tipo</th>
              <th className="num">Valor</th>
              <th>Ativo</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((coupon) => (
              <tr key={coupon.id}>
                <td>{coupon.code}</td>
                <td>{coupon.kind}</td>
                <td className="num">{coupon.value}</td>
                <td>{coupon.is_active ? "Sim" : "Não"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
